import React from 'react';
import { Grid, Button, Input, IconButton, Typography } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import { Add, Check } from '@material-ui/icons';
import * as api from '../../../api/api';
import { connect } from 'react-redux';
import DetailedExpansionPanel from './FileExpansion';
import {
  setFilesAction,
  typeAction,
  apllicantData
} from '../../../redux/actions/applicantAction';
// import isEmpty from '../../../validation/is-empty';
import { CompletedContext } from './StepperComponent';
import Feature from './feature.componet';
const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

function Scans(props) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone();

  const style = React.useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject]
  );

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const initialState = {
    passportURI: '',
    childDocURI: ''
  };
  const [completed, dispatch] = useCompleted();
  const fileInput = React.createRef();
  const [fileName, setFilname] = React.useState('');
  const [fileNameURI, setFilnameURI] = React.useState();
  const fileRef = React.createRef();

  const readURI = (e, type) => {
    // this.setState({imageURI:"", fileName:""});
    setFilnameURI('');
    if (e.target.files && e.target.files[0]) {
      // console.log("dsfsfsf","dfsfsfd")
      // this.setState({fileName:e.target.files[0].name});
      setFilname(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function(ev) {
        // this.setState({imageURI:ev.target.result});
        setFilnameURI(ev.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleChangeFile = (e, type) => {
    readURI(e, type); // maybe call this with webworker or async library?
    if (props.onChange !== undefined) props.onChange(e); // propagate to parent component
    // console.log("e",e)
  };

  // const filteredDocs = React.useMemo(() => {
  //   const hasDocs = docs.every(item => {
  //     // console.log(_.isEmpty(item.files));

  //     return _.isEmpty(item.files);
  //   });

  //   const filtered = props.docs.filter(item => {
  //     return item.id === 5 && 1
  //   })

  //   return filtered;
  // }, [props.docs]);

  // console.log(filteredDocs);

  // console.log(isDocsEmpty);

  // React.useEffect(() => {
  //   const newCompleted = completed;
  //   if (
  //     !isDocsEmpty
  //   ) {
  //     newCompleted[props.activeStep] = true;
  //     // props.setCompleted(newCompleted);
  //     // props.handleNext();
  //     dispatch({ type: 'COMPLETED', payload: newCompleted });
  //     // console.log('true', newCompleted);
  //   } else {
  //     // const newCompleted = props.completed;
  //     newCompleted[props.activeStep] = false;
  //     // props.setCompleted(newCompleted);
  //     dispatch({ type: 'COMPLETED', payload: newCompleted });
  //     // console.log('false', newCompleted);
  //   }
  // }, [props.docs])

  return (
    <>
      <Grid
        container
        justify="flex-start"
        alignItems="flex-end"
        direction="row"
        spacing={2}
      >
        <Grid item xs={12}>
          <Feature />
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            component="h3"
            color="error"
            className="text-center"
          >
            Увага!
          </Typography>
          <Typography variant="h4" component="h4" color="error">
            Для можливості подання заяви кількість документів повинна складати:
          </Typography>
          <Typography variant="p" component="p" color="error">
            Свідоцтво: не менше ніж 1 файл на кожну дитину
          </Typography>
          <Typography variant="p" component="p" color="error">
            Копія сплати ЄСП: не менше ніж 1 файл
          </Typography>
          <Typography variant="p" component="p" color="error">
            Довідка про місце проживання – якщо громадянство „Іноземний
            громадянин” або „Без громадянства” - не менше ніж 1 файл
          </Typography>
          <Typography variant="p" component="p" color="error">
            Копія рішення суду про опіку - Якщо в дитини заповнено поле „Дата
            встановлення опіки” – не менше ніж 1 файл
          </Typography>
        </Grid>
        {props.docs.map(item => (
          <DetailedExpansionPanel
            typeAction={props.typeAction}
            setFilesAction={props.setFilesAction}
            apllicantData={props.apllicantData}
            id={props.application.id}
            item={item}
            key={item.id}
          />
        ))}
      </Grid>
      {/* <Grid
        container
        direction="row"
       
        spacing={2}
      > */}
      {/* <Grid item xs={12}> */}
      {/* <Button
            disabled={props.activeStep === 0}
            onClick={props.handleBack}
            className="mr-2"
          >
            Назад
          </Button> */}
      {/* <Button
            variant="contained"
            color="primary"
            onClick={props.handleNext}
            className="mr-2"
          >
            Наступна
          </Button> */}
      {/* </Grid> */}
      {/* </Grid> */}
    </>
  );
}

const mapStateToProps = state => ({
  directories: state.directories,
  application: state.application,
  docs: state.docs.docs,
  applicant: state.applicant
});

export default connect(mapStateToProps, {
  setFilesAction,
  typeAction,
  apllicantData
})(Scans);
